module.exports = __webpack_public_path__ + "img/waybill_mockup.bec0900e.png";